// extracted by mini-css-extract-plugin
export default {"avatar":"UserMenu_avatar__L8Vzy","label":"UserMenu_label__ClmoR","username":"UserMenu_username__PGjVf","role":"UserMenu_role__y5UeX"};